import { useState, useEffect } from 'react'
import { Select } from 'antd'
import { getDataOptions } from '../helpers'
import withRepeater from './withRepeater'
import withDerivedData from './withDerivedData'
import { getNodeLabel } from 'Services/WeaverUtils'
{ Option } = Select

SequencedFormSelectInput = ({
  form
  formItem
  queries
  options
  config: { mode, showSearch } = {}
  derivedData
  props...
}) ->

  [loading, setLoading] = useState(true)
  [disabled, setDisabled] = useState(false)

  { initting, options } = withDerivedData({
    queries,
    derivedData
  })

  useEffect( ->
    setDisabled(options.length is 0)
    return if initting or !props.value
    isValInOptions = (val) ->
      options.find(({ value }) -> value is val)
    if mode is 'multiple'
      valid = (props.value or []).filter(isValInOptions)
      if !_.isEqual(valid, props.value) then props.onChange(valid)
    else
      if !isValInOptions(props.value) then props.onChange(undefined)
    undefined
  , [options])

  <Select
    mode={mode}
    loading={initting}
    showSearch={showSearch or true}
    optionFilterProp="children"
    placeholder={_.startCase(formItem)}
    filterOption={(input, option) ->
      { children: { props } } = option
      props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
    disabled={disabled}
    { props... }
  >
    {options.map((option) ->
      <Option
        disabled={option.disabled or false}
        key={option.value or option}
        value={option.value or option}
      >
        { option.label }
      </Option>
    )}
  </Select>

export default withRepeater(SequencedFormSelectInput, { selector: (value) -> value })
